import React, { useState } from 'react'
import globe from "../../assets/imgs/globe.webp"
import loaction1 from "../../assets/imgs/indianapolis.webp"
import loaction2 from "../../assets/imgs/chicago.webp"
import loaction3 from "../../assets/imgs/pune.webp"
import loaction4 from "../../assets/imgs/indore.webp"
import ssnonprofits from "../../assets/imgs/Small-staff-Nonprofits.webp"
import msnonprofits from "../../assets/imgs/Mid-sized-Nonprofits.webp"
import elnonprofits from "../../assets/imgs/Enterprise-level-Nonprofits.webp"
import { Modal } from 'react-bootstrap'
import Fcontact from '../Shared/Fcontact'

const WhyChoose = () => {
    const [show, setShow] = useState(false);
    const [policy, setPolicy] = useState(false);
  
    const handleClose = () => {
      setPolicy(false);
      setShow(false);
    };
    const handleShow = () => {
        setPolicy(true);
        setShow(true);
      };

    const AboutFunction = (eleme) => {
        const violation = document.getElementById(eleme);
        window.scrollTo({
          top: violation.offsetTop,
          behavior: "smooth",
        });
      };

    return (
        <div>
            <section id="whyChoose" className="rightCause">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 col-lg-5">
                            <h2 className="h1">
                                Why choose Right Cause Nonprofit software?
                            </h2>
                        </div>
                        <div className="col-md-7 col-lg-7 ps-5">
                            <p>We take a holistic approach to support, delivered by a dedicated team which comes included in
                                the subscription cost. That means unlimited support services beginning on day one,
                                implementation, licensing, strategic advice to get the most out of the Microsoft environment
                                and training when needed. All of this comes from people dedicatedly working towards
                                digitizing Nonprofit industry.</p>
                            <p>Right Cause available for organizations of all types and sizes. </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-4 text-center custmPadding">
                            <div className="cardWrapper">
                                <div className="pb-3">
                                    {/* <span className="icon-small-staff"></span> */}
                                    <img src={ssnonprofits} alt="Small-staff Nonprofits" width="76" height="76" />
                                    
                                </div>
                                <h4>Small-staff Nonprofits</h4>
                                <p>Out-of-the-box solutions, ready to kick-start with
                                    features as required. </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 text-center custmPadding">
                            <div className="cardWrapper">
                                <div className="pb-3">
                                    {/* <span className="icon-mid-sized"></span> */}
                                    <img src={msnonprofits} alt="Mid-sized Nonprofits" width="76" height="76" />
                                </div>
                                <h4>Mid-sized Nonprofits</h4>
                                <p>Additional functionality and standard tailoring
                                    capabilities. Available exclusively on subscription
                                    model or one-time payment. </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-lg-4 text-center custmPadding">
                            <div className="cardWrapper">
                                <div className="pb-3">
                                    {/* <span classame="icon-enterprise-level"></span> */}
                                    <img src={elnonprofits} alt="Enterprise-level Nonprofits" width="76" height="76" />
                                </div>
                                <h4>Enterprise-level Nonprofits </h4>
                                <p>Custom-built solution with advanced functionality, extensive tailoring capabilities, and
                                    optional third-party integrations. Available via the Microsoft Cloud. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="registerFree" className="registerFreeDiv">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5 col-lg-5">
                            <div className="location_div">
                                <div className="location_pin locationOne">
                                    <div className="countryName">Indianapolis</div> <img src={loaction1}
                                        alt="indianapolis" width="50" height="63" />
                                </div>
                                <div className="location_pin locationTwo">
                                    <div className="countryName">Chicago</div> <img src={loaction2} alt="Chicago"
                                        width="39" height="48" />
                                </div>
                                <div className="location_pin locationThree">
                                    <div className="countryName">Pune</div> <img src={loaction3} alt="Pune" width="30" height="37" />
                                </div>
                                <div className="location_pin locationFour">
                                    <div className="countryName">Indore</div> <img src={loaction4} alt="Indore" width="28"
                                        height="35" />
                                </div>
                                <div className="location_pin locationFive">
                                    <div className="countryName">Hyderabad</div> <img src={loaction3} alt="Hyderabad" width="30" height="37" />
                                </div>
                                <img alt="Right Cause Solution" src={globe} lt="Register for a free introductory tour" width="457" height="457" />
                            </div>
                        </div>
                        <div className="col-md-7 col-lg-7 ps-5">
                            <h2 className="h1">
                                Register for a free introductory tour
                            </h2>
                            <p>See right cause in action and get a guided tour for right cause solution and share your
                                specific requirements </p>
                            <div className="featureWrapper">
                                <div className="registerFeatures">
                                    <div className="featuresicon"><i className="icon-demo"></i></div>
                                    <p>1 hour Free<br />Demo</p>
                                </div>
                                <div className="registerFeatures">
                                    <div className="featuresicon"><i className="icon-multi"></i></div>
                                    <p>Multilingual<br />Ready</p>
                                </div>
                                <div className="registerFeatures">
                                    <div className="featuresicon"><i className="icon-consult_1"></i></div>
                                    <p>Change Management Consulting</p>
                                </div>
                            </div>
                            <a onClick={()=>AboutFunction("getStrated")} className="rc-primary-btn rc-large-btn rc-btn mt-3" tabIndex="0"
                                aria-label="Lets Connect Button">Lets Connect <i className="icon-arrow"></i></a>
                        </div>
                    </div>
                </div>
            </section>
            <Modal
                size="lg"
                show={show}
                onHide={handleClose}
                className="modal_getStartedForm"
            >
                <Modal.Header closeButton></Modal.Header>
                <Fcontact policy={policy} />
            </Modal>
        </div>
    )
}

export default WhyChoose